export default "__VITE_ASSET__DCMaSxLx__"